import React from "react";
import { MdClose } from "react-icons/md";
import { PiWarningBold } from "react-icons/pi";
import "../../styles/DeleteConfirmModal.css";

const StatusConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  partnerName,
  currentStatus,
  newStatus,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content-admin">
        <div className="modal-header">
          <h6>
            <span className="warning-icon me-1">
              <PiWarningBold />
            </span>
            Change Status
          </h6>
          <button className="close-btn text-black" onClick={onClose}>
            <MdClose />
          </button>
        </div>

        <div className="modal-body">
          <p>
            Are you sure you want to change the status of{" "}
            <strong>{partnerName}</strong> from <strong>{currentStatus}</strong>{" "}
            to <strong>{newStatus}</strong>?
          </p>
          {currentStatus === "active" && (
            <p>
              Login access will be disabled for <strong>OEM</strong> when the
              status is <strong>inactive</strong>.
            </p>
          )}
          {currentStatus === "inactive" && (
            <p>
              Login access will be enabled for <strong>OEM</strong> when the
              status is <strong>active</strong>.
            </p>
          )}{" "}
        </div>

        <div className="modal-footer-delete">
          <button className="delete-btn" onClick={onConfirm}>
            Yes, Change to {newStatus}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusConfirmModal;
